import {setTag} from '@sentry/react'
import {useLayoutEffect} from 'react'
import {ScrollRestoration, useLocation, useOutlet} from 'react-router-dom'

import {OverlayProvider} from '@sdox/ui'

import {AppToastContainer} from '../components/Toast/AppToastContainer'
import 'react-toastify/dist/ReactToastify.css'

const App = () => {
  const outlet = useOutlet()
  const location = useLocation()

  useLayoutEffect(() => {
    setTag('location', location.pathname)
  }, [location])

  return (
    <>
      <ScrollRestoration />
      <OverlayProvider>{outlet}</OverlayProvider>
      <AppToastContainer />
    </>
  )
}

export default App
